import {Falsy, NonFalsy} from "../types";

const valIsNotFalsy = <T>(val: T | Falsy): val is NonFalsy<T> => Boolean(val);
export const compact = <T>(list: T[]) => list.filter(valIsNotFalsy);
